import React, { useContext, useState } from 'react'
import { MyShipments } from '../../components/dashboard/myShipments'
import { BoughtProducts } from '../../components/dashboard/boughtProducts'

export default function MyOrdersPage() {

  const [bos, setBos] = useState(1)
  const [bought, setBought] = useState()
  const [sold, setSold] = useState()

  return (
    <div className="h-full relative flex flex-col gap-5">
      <div className="boughtOrSold flex gap-2 select-none">
        <div onClick={() => (bos !== 0) ? setBos(0) : ""} className={"px-5 py-2" + (bos === 0 ? " bg-gradient-to-r from-emerald-600 to-emerald-700 bg-pos-0 bg-size-200 text-white" : " border border-emerald-600 cursor-pointer")}>Køb</div>
        <div onClick={() => (bos !== 1) ? setBos(1) : ""} className={"px-5 py-2" + (bos === 1 ? " bg-gradient-to-r from-emerald-600 to-emerald-700 bg-pos-0 bg-size-200 text-white" : " border border-emerald-600 cursor-pointer")}>Salg</div>
      </div>
      {(bos === 0) ?
        <BoughtProducts data={bought} setData={setBought} />
      :
        <MyShipments data={sold} setData={setSold} />
      }
    </div>
  )
}